import { useEffect } from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Trans, useTranslation } from 'react-i18next'
import { paragraphStyle } from '../../utils/cssFunctions.js'
import HelmetMeta from '../../layouts/HelmetMeta.js'
import OtherPagesHeader from './OtherPagesHeader.js'

export default function About () {
  const { t } = useTranslation('others')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container sx={{ mb: 6 }} maxWidth='xl' disableGutters>
      <HelmetMeta
        {...{
        title: t('about.metaTitle'),
        description: t('about.metaDescription'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />
      <Box sx={{ position: 'relative' }}>
        <OtherPagesHeader
          {...{
          ratio: 1.5,
          image: 'https://d1hi0tbu2kom2c.cloudfront.net/img/about.jpg',
          title: 'PEAKS SPORTS',
          subtitle: t('about.headerSubtitle')
        }}
        />
      </Box>
      <Box sx={{ px: { xs: 2, md: 0 } }}>

        {[
          {
            content: <Trans ns='others' i18nKey='about.paragraph1' components={{ 1: <strong />, 2: <strong /> }} />
          },
          {
            content: t('about.paragraph2')
          },
          {
            content: <Trans ns='others' i18nKey='about.paragraph3' components={{ 1: <strong /> }} />
          },
          {
            content: t('about.paragraph4')
          },
          {
            content: <Trans ns='others' i18nKey='about.paragraph5' components={{ 1: <strong /> }} />
          },
          {
            content: <Trans ns='others' i18nKey='about.paragraph6' components={{ 1: <strong /> }} />
          },
          {
            content: <Trans ns='others' i18nKey='about.paragraph7' components={{ 1: <strong /> }} />
          },
          {
            content: t('about.paragraph8')
          }
        ].map((text, index) => (
          <Typography
            key={index}
            sx={{
              ...paragraphStyle,
              animationDelay: `${index * 0.15}s`
            }}
          >
            {text.content}
          </Typography>
        ))}
      </Box>
    </Container>
  )
}
